<template>
  <b-modal
    id="upload-image-modal"
    ref="upload-image-modal"
    :title="title"
    size="lg"
    hide-header-close
    @hide="closeUploadImageModal()"
    centered
  >
    <div
      class="card card-aside p-5 mb-0"
    >
      <div
        class="card-aside-column d-flex align-items-center justify-content-center"
      >
        <div
          id="img-preview-container"
        >
          <img
            :src="imageURL"
          >
        </div>
      </div>
      <div
        class="card-body p-0 ml-5"
      >
        <b-form-group>
          <template
            v-slot:label
            label-for="upload-image-modal-file-upload"
          >
            <h3
              class="mb-0 form-label"
            >
              File Upload
            </h3>
          </template>
          <base-image-input
            :value="newImage.file"
            @input="setImageUploadFile($event)"
            ref="image-file-upload"
          />
        </b-form-group>
        <b-form-group>
          <template
            v-slot:label
            label-for="upload-image-modal-url-upload"
          >
            <h3
              class="mb-0 form-label"
            >
              URL Upload
            </h3>
          </template>
          <b-form-input
            id="upload-image-modal-url-upload"
            :state="isValidURLUpload"
            type="url"
            :value="newImage.url"
            @input="setImageUploadURL($event)"
            placeholder="Image url"
            pattern="https?://.+"
          />
          <b-form-invalid-feedback
            id="upload-image-modal-url-upload-feedback"
            class="mb-0 text-danger mt-1"
          >
            <small>
              Please provid a valid image URL!
            </small>
          </b-form-invalid-feedback>
        </b-form-group>
        <p
          class="mb-0 text-muted"
        >
          <small
            class="text-muted"
          >
            Supported image types are:
            <span
              v-for="(type, index) in supportedImageTypes"
              :key="index"
            >{{ `".${type}"` }}<span v-if="index !== supportedImageTypes.length -1">, </span>
            </span>
          </small>
        </p>
        <p
          class="mb-0 text-muted"
        >
          <small
            class=""
          >
            Maximum image size is: {{ maxImageSize }}
          </small>
        </p>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button
        variant="tertiary"
        @click="closeUploadImageModal()"
        data-test="upload-image-modal-cancel-btn"
      >
        Cancel
      </b-button>
      <b-button
        variant="primary"
        :class="{ 'btn-loading': isUploadButtonLoading }"
        @click="uploadImage()"
        :disabled="!isValidUpload"
        data-test="upload-image-modal-upload-btn"
      >
        Upload
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import helper from '@/core/helper';
import urlHelper from '@/core/mixins/urlHelper';

function initialData() {
  return {
    isUploadButtonLoading: false,
    newImage: {
      file: null,
      url: '',
    },
    isValidUpload: false,
  };
}

export default {
  name: 'UploadImageModal',
  mixins: [
    urlHelper,
  ],
  props: {
    customProps: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return initialData();
  },
  computed: {
    title() {
      return this.customProps?.title || '';
    },
    imageURL() {
      if (this.newImage.file) return this.newImage.file.previewURL;
      if (this.newImage.url) return this.newImage.url;
      return this.customProps?.imageURL || '';
    },
    supportedImageTypes() {
      return this.customProps?.supportedTypes || [];
    },
    maxImageSize() {
      if (this.customProps.hasOwnProperty('maxSize')) {
        return `"${this.customProps.maxSize.size}${this.customProps.maxSize.unit.toUpperCase()}"`;
      }
      return '';
    },
    isValidURLUpload() {
      if (this.newImage.url === '') return null;
      return this.isValidUpload;
    },
    uploadType() {
      let uploadType = '';
      for (const type in this.newImage) {
        if (this.newImage[type]) uploadType = type;
      }
      return uploadType;
    },
  },
  methods: {
    setImageUploadFile(fileData) {
      if (this.isVaildFileUpload(fileData)) {
        this.newImage.file = fileData;
        this.isValidUpload = true;
      } else {
        this.newImage.file = null;
        this.isValidUpload = false;
      }
      this.resetImageUploadURL();
    },
    isVaildFileUpload(fileData) {
      return !!fileData?.previewURL;
    },
    resetImageUploadFile() {
      this.newImage.file = null;
    },
    setImageUploadURL: helper.debounce(function setImageUploadURL(url) {
      this.isValidUpload = this.isValidImageURL(url, this.supportedImageTypes);
      this.newImage.url = url;
      this.resetImageUploadFile();
    }, 500),
    resetImageUploadURL() {
      this.newImage.url = '';
    },
    uploadImage() {
      if (!this.uploadType) return this.closeUploadImageModal();
      this.$emit('uploadImage', {
        type: this.uploadType,
        value: this.newImage[this.uploadType],
      });
      this.isUploadButtonLoading = true;
      this.resetData();
    },
    closeUploadImageModal() {
      this.$emit('closeUploadImageModal');
      this.resetData();
    },
    resetData() {
      setTimeout(() => {
        Object.assign(this.$data, initialData());
      }, 500);
    },
  },
};
</script>
<style scoped lang="scss">
#img-preview-container {
  max-height: 260px;
  img {
    max-height: inherit;
    object-fit: contain;
  }
}
</style>
